import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import React, { useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "./Trending_Tours.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import CommonTitle from "../common_component/common_title/Common_Title";
import CommonTourCard from "../common_component/common_tour_card/Common_Tour_Card";

function TrendingTours({ titleText, data }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  // ✅ Handle both array and object formats
  const tours = data?.data || data || [];

  return (
    <section className="common-tour-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-8">
            <CommonTitle title={titleText} />
          </div>

          <div className="col-4 text-end">
            <div ref={prevRef} className="custom-arrow">
              <FontAwesomeIcon icon={faChevronLeft} />
            </div>

            <div ref={nextRef} className="custom-arrow">
              <FontAwesomeIcon icon={faChevronRight} />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="trending_tour_cards">
              <Swiper
                modules={[Navigation]}
                spaceBetween={25}
                loop={tours.length > 3} // ✅ Fix swiper issue
                onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                }}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  576: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                }}
              >
                {tours.map((tour, index) => (
                  <SwiperSlide key={index}>
                    <CommonTourCard
                      title={tour?.title}
                      img={tour?.images?.[0]?.image}
                      location={tour?.location?.name}
                      duration={tour?.duration}
                      places={tour?.places_covered}
                      activity={tour?.activities_count}
                      data={tour}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrendingTours;
